import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'
import { HeadingSmall, HeadingSmallProps } from './HeadingSmall'

interface IHeadingCardProps extends HeadingSmallProps {
  border?: boolean
}

const PADDING_STYLES = 'pb-1'
const NO_PADDING_STYLES = 'pb-0'

const NO_BORDER_STYLES = 'border-b-0'
const BORDER_STYLES = 'border-b border-solid border-contentareaborder'

const HEADING_CARD_STYLES =
  'text-secondary text-sm my-2 mx-0 relative text-left font-heading font-bold uppercase tracking-wide'

export const HeadingCard: React.FC<PropsWithChildren<IHeadingCardProps>> = ({
  border,
  margin,
  bold,
  textTransform,
  children,
  className,
}) => (
  <HeadingSmall
    margin={margin}
    bold={bold}
    textTransform={textTransform}
    className={concatStyles([
      HEADING_CARD_STYLES,
      border ? BORDER_STYLES : NO_BORDER_STYLES,
      margin ? PADDING_STYLES : NO_PADDING_STYLES,
      className,
    ])}
  >
    {children}
  </HeadingSmall>
)

HeadingCard.displayName = 'Content.HeadingCard'
